<script setup lang="ts">
definePageMeta({
  layout: "auth",
  name: "register.identifier",
  middleware: ["unauthenticated"],
});

const { t } = useI18n();
const localePath = useLocalePath();

useSeoMeta({
  title: () => t("register.title"),
  description: () => t("seo.register.description"),
});

const { form, save } = useRegisterSession();

const formComponent = useTemplateRef<{ isValid: boolean } | undefined>("formComponent");

const isLoading = ref(false);

const identifierError = ref<string | null>(null);
const approved = ref(false);
const approvedError = ref<string | null>(null);

watch(approved, (value) => {
  if (value) approvedError.value = null;
});

const onSubmit = async (): Promise<void> => {
  identifierError.value = null;
  if (!formComponent.value?.isValid) return;
  if (!approved.value) {
    approvedError.value = t("app.approval.required");
    return;
  }
  await save();
  navigateTo(localePath({ name: "register.settings" }));
};
</script>

<template>
  <AppAuthFormLayout :title="$t('register.title')" :description="$t('register.description')">
    <AppAuthFormIdentifier v-model="form" id="register-identifier-form" @submit="onSubmit" class="not-last:mb-6" ref="formComponent">
      <template #errors>
        <Transition name="fade">
          <AppMessageWrapper v-if="identifierError">
            {{ identifierError }}
          </AppMessageWrapper>
        </Transition>
      </template>
    </AppAuthFormIdentifier>
    <template #actions>
      <AppAuthApprovalField v-model="approved" :error-message="approvedError" class="mb-1" />
      <AppLoadingButton block hide-text-on-load form="register-identifier-form" type="submit" color="secondary" :loading="isLoading">
        {{ $t("ui.next") }}
      </AppLoadingButton>
      <div class="flex justify-center">
        <UButton variant="link" :to="$localePath('/signin')">{{ $t("register.unidentified") }}</UButton>
      </div>
    </template>
  </AppAuthFormLayout>
</template>
